// Whether a sitting's Section B cell can offer essay feedback, and which
// attempt it should open. Modelled on taraWritingFeedbackAccess.js: the
// workspace's own paper statuses order in-progress sittings ahead of
// completed ones, which is right for resuming an exam and wrong for finding
// an essay that was already written, so availability is asked about the
// paper and answered by the server, which is the only thing that knows where
// the essay actually is.

export function lnatSectionBFeedbackAccess({
  sectionBPaperId,
  dbPapers = {},
  availability = {},
  scoredSectionB = null,
} = {}) {
  const none = { available: false, attemptId: null, fromEarlierSitting: false };
  if (!sectionBPaperId) return none;

  const openAttemptId = dbPapers[sectionBPaperId]?.attempt_id || null;
  const forPaper = availability[sectionBPaperId];

  if (forPaper?.attempt_id) {
    return {
      available: true,
      attemptId: forPaper.attempt_id,
      fromEarlierSitting: Boolean(openAttemptId) && forPaper.attempt_id !== openAttemptId,
      stagesReady: forPaper.stages_ready ?? 0,
    };
  }

  if (scoredSectionB && openAttemptId) {
    return { available: true, attemptId: openAttemptId, fromEarlierSitting: false };
  }

  return none;
}
